import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProjectCreateDTO, ProjectDTO} from '../dto/project';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/project';

  getAllProjects(): Observable<ProjectDTO[]> {
    return this.http.get<ProjectDTO[]>(this.apiUrl);
  }

  getAllExploreProjects(): Observable<ProjectDTO[]> {
    return this.http.get<ProjectDTO[]>(`${this.apiUrl}/explore`);
  }

  getProjectById(id: number): Observable<ProjectDTO> {
    if (!id) {
      throw new Error('ProjectId is required');
    }
    return this.http.get<ProjectDTO>(`${this.apiUrl}/${id}`);
  }

  createProject(project: ProjectCreateDTO): Observable<ProjectDTO> {
    return this.http.post<ProjectDTO>(this.apiUrl, project);
  }

  updateProject(id: number, project: ProjectDTO): Observable<ProjectDTO> {
    if (!id) {
      throw new Error('ProjectId is required');
    }
    return this.http.put<ProjectDTO>(`${this.apiUrl}/${id}`, project);
  }

  deleteProject(id: number): Observable<HttpResponse<string>> {
    if (!id) {
      throw new Error('ProjectId is required');
    }
    return this.http.delete(`${this.apiUrl}/${id}`, {observe: 'response', responseType: 'text'});
  }
}
